<template>
  <div id="contents">
    <div class="recruit_point" >
      <div class="recruit_point_main move_view">
        <div class="title_area">
          <p class="title">コンテンツ制作の強み</p>
        </div>
        <div @click="close" class="close_icon">
          <img src="../assets/img/common/recruit_2021/close_icon.svg" />
        </div>
        <p class="caption">コンテンツ制作を専門に60年以上の実績を誇る当社のストロングポイントをまとめてみました。</p>
        <router-link v-bind:to="{name: 'program_index', params : { link: true }}">
          <div class="more">
            <p class="more_text">詳しい番組実績はこちら</p>
            <p class="more_arrow">▶︎</p>
          </div>
        </router-link>
      </div>
      <div id="recruit_point_section0" class="recruit_point_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/01.png" alt="01"></p>
        </div>
        <div class="program">
          <p class="title">テレビ朝⽇の多くの番組を制作しています！</p>
          <ul class="list">
            <li><img src="../assets/img/common/recruit_2021/program_logo/good_morning_logo.png" alt="グッド！ モーニング"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/morning_show_logo.png" alt="モーニングショー"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/scramble_logo.png" alt="ワイド！ スクランブル"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/J_channel_logo.png" alt="J チャンネル"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/jyun_sanpo_logo.png" alt="じゅん散歩"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/tetuko_no_heya_logo.png" alt="徹子の部屋"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/jinsei_no_rakuen_logo.png" alt="人生の楽園"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/Qsama_logo.png" alt="Qさま"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/hanataka_logo.png" alt="ハナタカ!優越館"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/sport_ou_logo.png" alt="スポーツ王は俺だ"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/nobunaka_logo.png" alt="ノブナカなんなん？"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/news_reader_logo.png" alt="ニュースリーダー"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/sunday_live_logo.png" alt="サンデー LIVE！！"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/gohan_japan_logo.png" alt="ごはんジャパン"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/syokusai_logo.png" alt="食彩の王国"></li>
            <li><img src="../assets/img/common/recruit_2021/program_logo/zenryoku_logo.png" alt="全力坂"></li>
          </ul>
        </div>
      </div>
      <div id="recruit_point_section1" class="recruit_point_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/02.png" alt="02"></p>
        </div>
        <div class="platform">
          <p class="title">テレビ各局からWebまで、幅広いプラットフォーム</p>
          <p class="text">テレビ各局はもちろん、インターネット動画、劇場映画、イベント・ステージ演出など、あらゆるメディアでのコンテンツ制作を手がけています。自分次第でどんなことにも挑戦できる環境です。</p>
          <ul class="list">
            <li>テレビ</li>
            <li>イベント</li>
            <li>Web</li>
            <li>広告</li>
          </ul>
        </div>
      </div>
      <div id="recruit_point_section2" class="recruit_point_list">
        <div class="number_area">
          <p class="number"><img src="../assets/img/common/recruit_2021/point/03.png" alt="03"></p>
        </div>
        <div class="genre">
          <p class="title">報道からバラエティまでジャンルを問わない番組制作</p>
          <p class="text">報道・情報系番組の生放送から、バラエティ、ドキュメンタリー、ドラマ・映画の企画制作まで、オールジャンルの番組制作実績があります。やりたいことが必ず見つかります。</p>
          <ul class="list">
            <li>バラエティ</li>
            <li>報道</li>
            <li>ドキュ<br />メンタリー</li>
            <li>ドラマ</li>
            <li>映画</li>
          </ul>
        </div>
      </div>
    </div>
  </div><!-- #contents -->
</template>
<script>
export default {
  name: 'recruit_info',
  data() {
    return {
      info_post: null,
      request_id: null,
      loading: false,
      post_list: null,
      error: null,
    }
  },
  props: [
    'info_layout_status',
    'request_tag_id'
  ],
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)

    //animation
    this.$nextTick(() => {
      var secTopArr = new Array();
      var current = -1;
      $('.recruit_point_list').each(function (i) {
        secTopArr[i] = $(this).offset().top;
      });
      $(window).scroll(function () {
        for (var i = secTopArr.length-1; i>=0; i--) {
          if ($(window).scrollTop() > secTopArr[i] - 450) {
            if (i != current) {
              $('#recruit_point_section'+i).addClass('move_view');
              current = i;
              break;
            }
          }
        }
      });
    });

  },
  methods: {
    close(){
      this.$emit('close_icon');
    }
  },
}
</script>

<style scoped lang="sass">
  @mixin recruit_font($size, $line-height, $letter-spacing)
    font-family: 'Noto Sans JP', sans-serif
    font-weight: 700
    font-size: $size
    line-height: $line-height
    letter-spacing: $letter-spacing

  .recruit_point
    .title
      position: relative
      overflow: hidden
      opacity: 0
      display: inline-block
      &::before
        content: ""
        display: block
        position: absolute
        background: #fff
        top: 0
        left: -10%
        width: 120%
        height: 100%
        z-index: 50
        -webkit-transform: skewX(10deg)
        transform: skewX(10deg)
    .text
      position: relative
      overflow: hidden
      opacity: 0
      display: inline-block
      &::before
        content: ""
        display: block
        position: absolute
        background: #fff
        top: 0
        left: -10%
        width: 120%
        height: 100%
        z-index: 50
        -webkit-transform: skewX(10deg)
        transform: skewX(10deg)
    &_main
      width: 1000px
      margin: 0 auto
      margin-top: 155px
      padding-bottom: 58px
      background-color: #fff
      position: relative
      .title_area
        position: absolute
        top: -44px
        left: 67px
      .title
        @include recruit_font(41px, 79px, 7px)
        color: #fff
        background: #FFBA00
        padding: 0 37px 0 20px
        display: table
      .close_icon
        position: absolute
        right: 0px
        top: -62px
        img
          width: 40px
          height: 40px
      a
        color: #000
        text-decoration: none
      .caption
        @include recruit_font(16px, 28px, 3px)
        margin-top: 97px
        padding: 0 66px 0 66px
        height: 52px
        display: inline-block
      .more
        display: flex
        border-bottom: 3px dashed #FF7689
        margin-left: 681px
        padding-bottom: 7px
        width: 249px
        &_text
          @include recruit_font(16px, 24px, 3px)
        &_arrow
          @include recruit_font(16px, 24px, 0px)
          margin-left: 24px
    &_list
      width: 1000px
      margin: 0 auto
      margin-top: 12px
      background-color: #fff
      position: relative
      &:last-child
        margin-bottom: 163px
      .number_area
        position: absolute
        top: 45px
        left: -30px
        display: flex
      .number
        @include recruit_font(55px, 66px, 7px)
        color: #fff
        background: #FFBA00
        padding: 0 12px 0 81px
        display: table
        position: relative
        overflow: hidden
        opacity: 0
        img
          margin-top: 11px
          width: 61px
          height: 55px

        &::before
          content: ""
          display: block
          position: absolute
          background: #fff
          top: 0
          left: -10%
          width: 120%
          height: 100%
          z-index: 50
          -webkit-transform: skewX(10deg)
          transform: skewX(10deg)
      .program
        padding-top: 56px
        padding-bottom: 58px
        .title
          @include recruit_font(28px, 42px, 4px)
          margin: 0 0 30px 148px
        .list
          margin: 0 29px 0 29px
          display: flex
          flex-wrap: wrap
          li
            width: 25%
            height: 127px
            position: relative
            opacity: 0
          img
            width: 100%
      .genre
        padding-top: 42px
        padding-bottom: 118px
        .title
          @include recruit_font(28px, 44px, 2px)
          margin: 0 0 11px 156px
        .text
          @include recruit_font(16px, 28px, 3px)
          margin: 0 0 62px 156px
          width: 774px
          height: 82px
        .list
          margin: 0 auto
          width: 786px
          display: flex
          flex-wrap: wrap
          justify-content: space-between
          li
            position: relative
            opacity: 0
            width: 130px
            height: 130px
            background-color: #FF7689
            @include recruit_font(16px, 28px, 3px)
            display: flex
            align-items: center
            justify-content: center
            text-align: center
            border-radius: 65px
            color: #fff
            &:not(:last-child)
              margin-right: 0px
      .platform
        padding-top: 40px
        padding-bottom: 78px
        .title
          @include recruit_font(28px, 44px, 3px)
          margin: 0 0 0 156px
        .text
          @include recruit_font(16px, 28px, 3px)
          margin: 0 0 62px 156px
          width: 774px
          height: 82px
        .list
          margin: 0 auto
          width: 686px
          display: flex
          flex-wrap: wrap
          justify-content: space-between
          li
            position: relative
            opacity: 0
            width: 143px
            height: 143px
            background-color: #FF7689
            @include recruit_font(19px, 28px, 2px)
            display: flex
            align-items: center
            justify-content: center
            text-align: center
            border-radius: 80px
            color: #fff


  .move_view
    .platform
      .list
        li
          -webkit-animation: listIn 2s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.3s
          animation: listIn 2s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.3s
          @keyframes listIn
            0%
              top: 180px
              opacity: 0
            30%
              opacity: 1
            100%
              top: 0px
              opacity: 1
    .genre
      .list
        li
          -webkit-animation: listIn 2s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.3s
          animation: listIn 2s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.3s
          @keyframes listIn
            0%
              top: 40px
              opacity: 0
            30%
              opacity: 1
            100%
              top: 0px
              opacity: 1
    .program
      .list
        li
          -webkit-animation: listIn 1.6s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.8s
          animation: listIn 1.6s 1 cubic-bezier(0.075, 0.82, 0.165, 1) forwards 0.8s
          @keyframes listIn
            0%
              top: 180px
              opacity: 0
            30%
              opacity: 1
            100%
              top: 0px
              opacity: 1
    .title
      opacity: 1
      &::before
        -webkit-animation: fadein0 1.8s 1 ease forwards
        animation: fadein0 1.8s 1 ease forwards
      @keyframes fadein0
        0%
          width: 150%
          left: -12.5%
          opacity: 1
        60%
          width: 150%
          left: 150%
          opacity: 1
        100%
          width: 150%
          left: 150%
          opacity: 0
    .text
      opacity: 1
      &::before
        -webkit-animation: textfadein0 1.8s 1 ease forwards
        animation: textfadein0 1.8s 1 ease forwards
      @keyframes textfadein0
        0%
          width: 150%
          left: -12.5%
          opacity: 1
        60%
          width: 150%
          left: 150%
          opacity: 1
        100%
          width: 150%
          left: 150%
          opacity: 0
    .number
      opacity: 1
      &::before
        -webkit-animation: fadein1 1.8s 1 ease forwards
        animation: fadein1 1.8s 1 ease forwards

      @keyframes fadein1
        0%
          width: 150%
          left: -12.5%
          opacity: 1
        60%
          width: 150%
          left: 150%
          opacity: 1
        100%
          width: 150%
          left: 150%
          opacity: 0

</style>



// WEBPACK FOOTER //
// src/components/recruit_point.vue